import { useState, useEffect } from 'react';
import useWindow from './useWindow.js';

const MEDIAQUERY_DEFAULTS = {
    xs: '0',
    xsMax: '575',
    sm: '576',
    smMax: '767',
    md: '768',
    mdMax: '991',
    lg: '992',
    lgMax: '1199',
    xl: '1200',
    xlMax: '1399',
    xxl: '1400'
};
const getQueryString = (query) => {
    return Array.isArray(query)
        ? `${query.reduce((total, current, idx) => {
            return `${total}(${current.type}-width: ${current.query}px)${idx === 0 ? ' and ' : ''}`;
        }, '')}`
        : `(${query.type}-width: ${query.query}px)`;
};
const useMediaQuery = (query, overrideNativeWindow) => {
    const window = useWindow(overrideNativeWindow);
    const queryString = typeof query === 'string' ? query : getQueryString(query);
    const mediaQuery = window?.matchMedia(queryString);
    const [match, setMatch] = useState(mediaQuery?.matches || false);
    useEffect(() => {
        const handler = () => setMatch(mediaQuery?.matches || false);
        mediaQuery?.addListener(handler);
        handler();
        return () => mediaQuery?.removeListener(handler);
    }, [mediaQuery]);
    return match;
};

export { MEDIAQUERY_DEFAULTS, useMediaQuery as default };
//# sourceMappingURL=useMediaQuery.js.map
